// FIXME
// @ts-nocheck
import { executeEvent } from "../../utils/misc";
import constants from "../../utils/constants";
import { sendBookInfo } from "../../utils/EngineDataColllector/EngineDataCollector";
import { pushPurchaseEvent, pushRefundEvent } from "../../helpers/EnhancedEcommerce";
import { Tracking } from "./tracking";
export function genericHandleCancellation(promise, stateUpdateOnError, reservation, roomStayId, quantity, defaultCurrency) {
    promise
        .then(() => {
        executeEvent(constants.EVENTS.CANCEL_RESERVATION);
        // GA4 refund event
        Tracking.sendRefundEvent(reservation, roomStayId, quantity, defaultCurrency);
        // GA3 refund event
        pushRefundEvent(reservation.get("id"), roomStayId, quantity);
        location.reload();
    })
        .catch(() => {
        stateUpdateOnError();
    });
}
export function genericOnBookingConfirmationMount(clearDataConditionsMet, clearData, getCountries, locale, reservationStatusConfirmed, reservation, propertyTicker, defaultCurrency, comiNeto) {
    if (clearDataConditionsMet) {
        clearData();
    }
    /* TODO: get only when there's the countries field on the customer form */
    if (typeof getCountries === "function") {
        getCountries(locale);
    }
    if (reservationStatusConfirmed) {
        sendBookInfo({ booked: true });
        window.wbkReservationId = reservation.get("id");
        executeEvent(constants.EVENTS.RESERVATION_SUCCESS);
        // GA4 purchase event
        Tracking.sendPurchaseEvent(reservation, defaultCurrency);
        // GA3 purchase event
        pushPurchaseEvent(propertyTicker, comiNeto, {
            id: reservation.get("id"),
            totalRate: reservation.get("roomReservations").reduce((acc, roomStay) => {
                return roomStay.get("totalAmount").get("amount") + acc;
            }, 0),
            currency: defaultCurrency,
            promoCodes: reservation.get("promoCodes"),
            roomStays: reservation.get("roomReservations").map(roomStay => ({
                id: roomStay.get("confirmationId"),
                ticker: roomStay.get("accommodationTicker"),
                title: roomStay.get("accommodationType"),
                configurationName: roomStay.get("roomConfiguration"),
                mealPlanName: roomStay.get("mealPlan"),
                conditionName: roomStay.get("condition").get("name"),
                quantity: roomStay.get("quantity"),
                totalRate: roomStay.get("totalAmount").get("amount"),
                extras: roomStay.get("selectedServices") &&
                    roomStay
                        .get("selectedServices")
                        .map(extra => extra.get("ticker"))
                        .join(","),
            })),
        });
    }
    else {
        // We leave START_CONFIRMATION event for legacy purposes, some hotels actually use this event
        executeEvent(constants.EVENTS.START_CONFIRMATION);
        executeEvent(constants.EVENTS.RESERVATION_RECEIPT);
    }
}
